import React, { useState, useEffect } from 'react';
import { SearchBox } from '../../../../app/common/sharedComponents/SearchBox';
import { ISelectedOption } from '../../../../app/@types/searchBox';
import { MultiUserLookupLogic } from '../../../../app/@types/myAudit';
import { useTranslation } from 'react-i18next';
import { handleOptionClickUtil } from '../../../../app/common/sharedComponents/SearchBox/utils';
import { ISearchBoxContainsUsers } from '../../../../app/@types/selfAssessmentFilter';
import { useSearchUser } from '../../../../app/common/hooks/useSearchUser';

export function SearchBoxContainsUsers ({
  callBackSelectedOptions,
  clearFilter,
  selectedUsers,
  selectedAndOrOption,
}: ISearchBoxContainsUsers) {
  const showTags: boolean = true;
  const { t } = useTranslation();
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
    setSearchBoxOptions,
  } = useSearchUser(selectedUsers);
  const [checkRadioButton, setCheckRadioButton] =
    useState<MultiUserLookupLogic>(selectedAndOrOption);

  useEffect(() => {
    return () => {
      setSearchText('');
      setSearchBoxOptions([]);
      setSelectedOptions([]);
    };
  }, [clearFilter]);

  useEffect(() => {
    if (selectedOptions && selectedOptions.length > 0) {
      createContainsUsers();
      setSearchText('');
    }
  }, [selectedOptions, checkRadioButton]);

  function handleInputChange (value: string) {
    setSearchText(value);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  function createContainsUsers () {
    const containsUserSeachValue = {
      list: selectedOptions,
      logic: checkRadioButton,
    };
    callBackSelectedOptions(containsUserSeachValue);
  }

  function removeTag (tagIndex: number) {
    const filteredRemovedTag = selectedOptions.filter(
      (_, index) => index !== tagIndex
    );
    const containsUserSeachValue = {
      list: filteredRemovedTag,
      logic: null,
    };
    setSelectedOptions(filteredRemovedTag);
    callBackSelectedOptions(containsUserSeachValue);
  }
  function clearSearch () {
    setSearchText('');
    if (!showTags) {
      setSelectedOptions([]);
    }
  }

  function handleClickRadioButton (checkedButton: MultiUserLookupLogic) {
    setCheckRadioButton(checkedButton);
  }

  return (
    <SearchBox
      handleInputChange={handleInputChange}
      searchBoxOptions={searchBoxOptions}
      handleOptionClick={handleOptionClick}
      selectedOptions={selectedOptions}
      searchTextName={searchText}
      clearSearch={clearSearch}
      placeholderText={t(
        'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
      )}
      label={t('COMMON.ACTION_PLAN.LABEL.CONTAINS')}
      showTags={showTags}
      showRadioButton={true}
      radioButtonCheckedType={checkRadioButton}
      removeTag={removeTag}
      handleClickRadioButton={handleClickRadioButton}
    />
  );
}
